import Col from 'react-bootstrap/Col';
import classnames from 'classnames';

export type Article = {
  title: string;
  description: string;
  urlToImage: string;
  url: string;
  publishedAt: string;
};

export type ArticleRowProps = { className?: string } & Article;

export const ArticleRow = ({ className, title, description, urlToImage, url, publishedAt }: ArticleRowProps) => {
  return (
    <a className={classnames('row text-body text-decoration-none', className)} href={url} target="_blank" rel="noreferrer">
      <Col sm={6} lg={12} xl={4}>
        <div className="article-image border bg-light" style={{ backgroundImage: `url(${urlToImage})` }}/>
      </Col>
      <Col>
        <small className="text-muted mb-2 d-block">{String(new Date(publishedAt))}</small>
        <h6>{title}</h6>
        <p>{description}</p>
      </Col>
    </a>
  )
}
